import * as tslib_1 from "tslib";
import { CandidateAdditionalDetails } from "../../../models/candidateAdditionalDetails";
import { ScreeningExecutionResult } from "../../../models/screeningExecutionResult";
var FeedbackExecutionController = /** @class */ (function () {
    /*@ngInject*/
    function FeedbackExecutionController($rootScope, $scope, $timeout, $uibModal, $uibModalStack, companyService, feedbackExecutionService, userRoleService, jobMatchService, candidateService, meetingService, modalService, dateTimeUtilityService, alertsAndNotificationsService, sharedService, MESSAGECONSTANTS, outreachService, jobService, authService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$uibModalStack = $uibModalStack;
        this.companyService = companyService;
        this.feedbackExecutionService = feedbackExecutionService;
        this.userRoleService = userRoleService;
        this.jobMatchService = jobMatchService;
        this.candidateService = candidateService;
        this.meetingService = meetingService;
        this.modalService = modalService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedService = sharedService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.outreachService = outreachService;
        this.jobService = jobService;
        this.authService = authService;
    }
    FeedbackExecutionController.prototype.$onChanges = function (changes) {
        // console.log(changes);
        var hasUsersListChanged = this._isNotInit(changes) && changes.usersToEditFeedback !== undefined && this._hasFeedbackUsersChanged(changes);
        if (hasUsersListChanged) {
            this.setFeedbackEnabledAttendeeId();
        }
        if (changes.activeOutreachFeedbackQuestionsList) {
            this.setOutreachQuestionsForFeedback(changes.activeOutreachFeedbackQuestionsList.currentValue);
        }
        if (changes.outreachData && !changes.outreachData.isFirstChange() && changes.outreachData.currentValue) {
            this.setOutreachFeedbackData(changes.outreachData.currentValue);
        }
    };
    FeedbackExecutionController.prototype._hasFeedbackUsersChanged = function (changes) {
        if (_.isEmpty(changes.usersToEditFeedback.previousValue)) {
            return true;
        }
        var previousAttendees = changes.usersToEditFeedback.previousValue.map(function (attendee) { return attendee.attendeeId; }).sort();
        var currentAttendees = changes.usersToEditFeedback.currentValue.map(function (attendee) { return attendee.attendeeId; }).sort();
        return !_.isEqual(previousAttendees, currentAttendees);
    };
    FeedbackExecutionController.prototype._isNotInit = function (changes) {
        return changes.externalMeetingCallId == undefined;
    };
    FeedbackExecutionController.prototype.$onInit = function () {
        // initialize variables
        this.totalClQnsCount = 0;
        this.totalCount = 0;
        this.recruiterqns = null;
        this.companyQnsComplete;
        this.type;
        this.externalNotesAction = {};
        this.companyId = null;
        this.feedbackQuestionsCompanyId = null;
        this.loggedInUserId = null;
        this.showMeetingLink = false;
        this.isCorporateFlag = false;
        this.showInterested = true;
        this.savingFlag = false;
        this.completingFlag = false;
        this.saveComplete = false;
        this.displayQuestions = false;
        this.userList = [];
        this.savedRecruiterQns;
        this.userGetRecruiterQns;
        this.jobMatch;
        this.candidateJobMatch = {};
        this.displayRecruiterName = false;
        this.feedbackTypeLabel = '';
        this.noEditableMeetingsLabel = '';
        this.completeButtonLabel = '';
        this.userId = null;
        this.chosenUser = null;
        this.chosenMeeting = null;
        this.screeningFeedbackStartedData = null;
        this.previousEnableEditFor = null;
        // flags
        this.loadingJobMatchDetailsFlag = false;
        this.loadingFeedbackOptionsFlag = false;
        this.loadingFeedbackDetailsFlag = false;
        this.showAdditionalCandidateDetailsFlag = false;
        this.showMeetingsFlag = false;
        this.editableMeetingsExistFlag = false;
        this.clientOrBuExists = true;
        this.userHasAccessToFeedback = false;
        this.showAllCompanyQuestionComments = true;
        this.showAllClientQuestionComments = true;
        this.loadingUsers = true;
        this.showChosenUserDetails = true;
        this.isCompanyQuestionExists = false;
        // this.disableRequestToEditButton = false;
        this.getAllPreferredJobTypes();
        this.getSalaryDurationOptions();
        this.init(false);
        if (this.externalMeetingCallId) {
            this._setMeetingListeners();
        }
        this._checkAndSaveFeedbackIfMeetingEnd();
        // Formalize comments (Users only)
        this.formalizeItemsArray = this._getAllItemsArray();
    };
    FeedbackExecutionController.prototype.init = function (refreshFlag) {
        var _this = this;
        if (this.loginRequired == undefined) {
            this.loginRequired = true;
        }
        if (this.parentScheduleId == undefined) {
            this.parentScheduleId = null;
        }
        if (this.childScheduleId == undefined) {
            this.childScheduleId = null;
        }
        if (this.externalCommentRequired == undefined) {
            this.externalCommentRequired = false;
        }
        if (this.usersToEditFeedback == undefined) {
            this.usersToEditFeedback = [];
        }
        if (this.feedbackReadOnly == undefined) {
            this.feedbackReadOnly = false;
        }
        if (this.context == 'conference' && this.externalMeetingCallId) {
            this.setFeedbackEnabledAttendeeId();
        }
        this.meetingsList = [];
        this.loggedInUserId = this.authService.getUserDetails().id;
        this.companyId = this.authService.getUserDetails().company.companyId;
        this.isCorporateFlag = (this.authService.getUserDetails().company.companyType === this.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE);
        this.feedbackExecutionResult = new ScreeningExecutionResult();
        this._setLabels();
        if (!_.isUndefined(refreshFlag) && refreshFlag) {
            this.loadingFeedbackOptionsFlag = true;
            this.loadingFeedbackDetailsFlag = true;
        }
        else {
            this.loadingJobMatchDetailsFlag = true;
        }
        this.isCandidateContactDetailsMissing = false;
        this.isCandidateContactAdditionalDetailsMissing = false;
        if (this.context === 'outreach') {
            this.getOutreachFeedbackQuestions();
        }
        else {
            this.getCandidateJobMatchCardInfo(refreshFlag, function () {
                _this.loadingJobMatchDetailsFlag = false;
                if (_this.feedbackType == 'Screening') {
                    _this.loadingFeedbackOptionsFlag = true;
                    _this.getUserList(function () {
                        _this.loadingFeedbackOptionsFlag = false;
                        _this.showChosenUserDetails = true;
                        if (_this._isCorporateAccessingVendorCandidateFeedback()) {
                            _this.chosenUser = _this.userList[0];
                            _this.feedbackEntityChanged();
                            _this.showChosenUserDetails = false;
                        }
                        // if a user id was passed in to the directive
                        else if (!_.isUndefined(_this.feedbackUserIdsList) && _this.feedbackUserIdsList.length > 0) {
                            if (_.isUndefined(refreshFlag) || !refreshFlag) {
                                // if it is not refresh mode
                                if (!_.isUndefined(_this.feedbackUserIdsList) && _this.feedbackUserIdsList.length > 0) {
                                    // if feedbackUserIdsList is not undefined / not passed in
                                    _this.feedbackUserIdsList = JSON.parse(_this.feedbackUserIdsList);
                                }
                            }
                            var passedInUser_1 = {};
                            angular.forEach(_this.userList, function (val, key) {
                                angular.forEach(_this.feedbackUserIdsList, function (passedInUserId, key) {
                                    if (val.id == passedInUserId) {
                                        passedInUser_1 = val;
                                        _this.userId = val.id;
                                    }
                                });
                            });
                            _this.userList = [];
                            _this.userList.push(passedInUser_1);
                            _this.chosenUser = passedInUser_1;
                            _this.feedbackEntityChanged();
                        }
                        else if (_this.userList.length == 1) {
                            _this.chosenUser = _this.userList[0];
                            _this.feedbackEntityChanged();
                        }
                        else {
                            // there exist multiple users and refresh flag is true
                            if (!_.isUndefined(refreshFlag) && refreshFlag) {
                                _this.$timeout(function () {
                                    $('#chosenUser-' + _this.chosenUser.id).prop("checked", true);
                                }, 500);
                                // reload the feedback data
                                _this.feedbackEntityChanged();
                            }
                        }
                        _this.checkRecruiterScreeningStatus();
                    }, function () {
                        _this.loadingFeedbackOptionsFlag = false;
                    });
                }
                else if (_this.feedbackType == 'Interview') {
                    _this.showMeetingsFlag = false;
                    _this.loadingFeedbackOptionsFlag = true;
                    var loggedInUserId = null;
                    if (!_this.loginRequired) {
                        loggedInUserId = _this.loggedInUserId;
                    }
                    _this.jobMatchService.getInterviewers(_this.jobMatchId, _this.companyId, loggedInUserId, false, function (data) {
                        _this._massageMeetingDetails(data, refreshFlag);
                    }, function (error) {
                        _this.loadingFeedbackOptionsFlag = false;
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
                else if (_this.feedbackType == 'PhoneScreen') {
                    _this.showMeetingsFlag = false;
                    _this.loadingFeedbackOptionsFlag = true;
                    var loggedInUserId = null;
                    if (!_this.loginRequired) {
                        loggedInUserId = _this.loggedInUserId;
                    }
                    _this.jobMatchService.getPhoneScreeners(_this.jobMatchId, _this.companyId, loggedInUserId, false, function (data) {
                        _this._massageMeetingDetails(data, refreshFlag);
                    }, function (error) {
                        _this.loadingFeedbackOptionsFlag = false;
                        _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
            });
        }
    };
    FeedbackExecutionController.prototype._onCommentChange = function () {
        try {
            this.formalizeItemsArray = this._getAllItemsArray();
        }
        catch (e) {
            this.formalizeItemsArray = [];
        }
    };
    FeedbackExecutionController.prototype._getAllItemsArray = function () {
        var _this = this;
        var out = [];
        if (!this.recruiterqns)
            return out;
        // 1) Company questions
        try {
            var coKey = this.feedbackQuestionsCompanyId;
            var companyQuestions = this.recruiterqns.companyQuestionsResults && this.recruiterqns.companyQuestionsResults[coKey] ? this.recruiterqns.companyQuestionsResults[coKey] : [];
            companyQuestions.forEach(function (q) {
                var text = (q.recruiterComment || q.recruiterNote || '').trim();
                if (text && String(text).trim().length > 0) {
                    var id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                    out.push({ key: "company-" + id, label: q.question || 'Company Comment', text: text, companyName: _this.recruiterqns.companyName || null });
                }
            });
        }
        catch (e) { }
        // 2) Client questions
        try {
            var clientResults_1 = this.recruiterqns.clientQuestionsResults || {};
            Object.keys(clientResults_1).forEach(function (clientKey) {
                var arr = clientResults_1[clientKey] || [];
                arr.forEach(function (q) {
                    var text = (q.recruiterComment || q.recruiterNote || '').trim();
                    if (text && String(text).trim().length > 0) {
                        var id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                        out.push({ key: "client-" + clientKey + "-" + id, label: q.question || 'Client Comment', text: text, companyName: _this.recruiterqns.clientDetails ? _this.recruiterqns.clientDetails[clientKey] : null });
                    }
                });
            });
        }
        catch (e) { }
        // 3) Job questions
        try {
            var jobResults_1 = this.recruiterqns.jobQuestionsResults || {};
            Object.keys(jobResults_1).forEach(function (jobKey) {
                var arr = jobResults_1[jobKey] || [];
                arr.forEach(function (q) {
                    var text = (q.recruiterComment || q.recruiterNote || '').trim();
                    if (text && String(text).trim().length > 0) {
                        var id = q.id != null ? String(q.id) : Math.random().toString(36).slice(2, 8);
                        out.push({ key: "job-" + jobKey + "-" + id, label: q.question || 'Job Comment', text: text, companyName: _this.recruiterqns.companyName || null });
                    }
                });
            });
        }
        catch (e) { }
        return out;
    };
    FeedbackExecutionController.prototype.handleBulkSave = function (updatedItems) {
        var _this = this;
        var items = (updatedItems && updatedItems.entity && updatedItems.entity.items) ? updatedItems.entity.items : updatedItems;
        if (!items || !Array.isArray(items))
            return;
        items.forEach(function (u) {
            var key = u.key || '';
            try {
                if (key.indexOf('company-') === 0) {
                    var id_1 = key.substring('company-'.length);
                    Object.keys(_this.recruiterqns.companyQuestionsResults || {}).forEach(function (k) {
                        var arr = _this.recruiterqns.companyQuestionsResults[k];
                        if (Array.isArray(arr)) {
                            arr.forEach(function (q) { if (String(q.id) == String(id_1))
                                q.recruiterComment = u.text; });
                        }
                    });
                }
                else if (key.indexOf('client-') === 0) {
                    var parts = key.split('-');
                    var clientKey = parts[1];
                    var id_2 = parts.slice(2).join('-');
                    var arr = (_this.recruiterqns.clientQuestionsResults && _this.recruiterqns.clientQuestionsResults[clientKey]) || [];
                    arr.forEach(function (q) { if (String(q.id) == String(id_2))
                        q.recruiterComment = u.text; });
                }
                else if (key.indexOf('job-') === 0) {
                    var parts = key.split('-');
                    var jobMatchId = parts[1];
                    var id_3 = parts.slice(2).join('-');
                    var arr = (_this.recruiterqns.jobQuestionsResults && _this.recruiterqns.jobQuestionsResults[jobMatchId]) || [];
                    arr.forEach(function (q) { if (String(q.id) == String(id_3))
                        q.recruiterComment = u.text; });
                }
            }
            catch (e) {
                // ignore mapping errors
            }
        });
        // Persist changes by invoking the existing saveResults flow
        // this.saveResults('save');
        // Exit formalize mode
        this.formalizeMode = false;
        this.formalizeItems = null;
        this.selectedComments = {};
        this.selectedCommentsMap = {};
    };
    FeedbackExecutionController.prototype.onToggleSelect = function (key, obj, prop, label) {
        if (!this.selectedComments)
            this.selectedComments = {};
        if (!this.selectedCommentsMap)
            this.selectedCommentsMap = {};
        if (this.selectedComments[key]) {
            this.selectedCommentsMap[key] = { obj: obj, prop: prop, label: label || key };
        }
        else {
            delete this.selectedCommentsMap[key];
        }
    };
    FeedbackExecutionController.prototype.hasSelectedComments = function () {
        return this.selectedCommentsMap && Object.keys(this.selectedCommentsMap).length > 0;
    };
    FeedbackExecutionController.prototype._getSelectedItemsArray = function () {
        var _this = this;
        var out = [];
        if (!this.selectedCommentsMap)
            return out;
        Object.keys(this.selectedCommentsMap).forEach(function (k) {
            var m = _this.selectedCommentsMap[k];
            var companyOrClient = null;
            // Try to infer client/company name from the selected item.
            // Keys for selections use patterns like:
            //  - 'company-<questionId>'
            //  - 'client-<clientKey>-<questionId>'
            //  - 'overall-<questionId>'
            // For client selections we can look up recruiterqns.clientDetails[clientKey].
            if (k && k.indexOf('client-') === 0) {
                var parts = k.split('-');
                var clientKey = parts.length >= 2 ? parts[1] : null;
                if (clientKey && _this.recruiterqns && _this.recruiterqns.clientDetails) {
                    companyOrClient = _this.recruiterqns.clientDetails[clientKey] || null;
                }
            }
            // For company / overall, use top-level company name when available
            if (!companyOrClient && k && (k.indexOf('company-') === 0 || k.indexOf('overall-') === 0)) {
                companyOrClient = _this.recruiterqns && _this.recruiterqns.companyName ? _this.recruiterqns.companyName : null;
            }
            // Fallback to any name available on the object itself
            if (!companyOrClient && m.obj) {
                companyOrClient = m.obj.companyName || m.obj.clientOrBUName || m.obj.clientName || m.obj.company || m.obj.client || m.obj.CompanyName || null;
            }
            var textVal = (m.obj && m.obj[m.prop]) ? m.obj[m.prop] : '';
            if (textVal && String(textVal).trim().length > 0) {
                out.push({ key: k, label: m.label, text: textVal, companyName: companyOrClient });
            }
        });
        return out;
    };
    FeedbackExecutionController.prototype._isCorporateAccessingVendorCandidateFeedback = function () {
        return this.companyService.isCorporateCompany() && !this._isUserOfSameCompany(this.userList[0].id);
    };
    FeedbackExecutionController.prototype.setFeedbackEnabledAttendeeId = function () {
        var _this = this;
        this.loadingUsers = true;
        this.meetingService.getFeedbackEditEnabledAttendeeId(this.externalMeetingCallId, function (data) {
            _this.enableEditForAttendeeId = data.attendeeId;
            _this.previouslyEnabledEditForAttendeeId = data.attendeeId;
            _this._setUserToEditFeedback();
        }, function (error) {
            //do nothing
        });
    };
    FeedbackExecutionController.prototype._setMeetingListeners = function () {
        var _this = this;
        this.cleanUpMeetingEventOne = this.$rootScope.$on("PARTICIPANT_FEEDBACK_EDIT_REQUEST", function (event, message) {
            _this.openEditFeedbackApprovalModal(message);
        });
        this.cleanUpMeetingEventTwo = this.$rootScope.$on("PARTICIPANT_FEEDBACK_EDIT_REJECT", function (event, message) {
            // this.disableRequestToEditButton = false;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Edit Request Denied</strong></div>",
                message: 'Your request to edit the feedback has been denied. Please try again later.',
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    //do nothing
                }
            });
        });
        this.cleanUpMeetingEventThree = this.$rootScope.$on("REFRESH_FEEDBACK_TAB", function (event, message) {
            _this.init(true);
        });
    };
    FeedbackExecutionController.prototype._setUserToEditFeedback = function () {
        var _this = this;
        this.loadingUsers = true;
        if (this.usersToEditFeedback && this.usersToEditFeedback.length > 0) {
            this.enabledEditForUser = this.usersToEditFeedback.find(function (user) { return user.attendeeId == _this.enableEditForAttendeeId; });
            if (this.enabledEditForUser !== undefined) {
                this.feedbackReadOnly = this.enabledEditForUser.displayName !== 'You';
                this.previousEnableEditFor = angular.copy(this.enabledEditForUser);
            }
        }
        this.$timeout(function () {
            _this.loadingUsers = false;
        }, 2000);
    };
    FeedbackExecutionController.prototype._setLabels = function () {
        var _this = this;
        if (_.isNull(this.feedbackType) || _.isUndefined(this.feedbackType)) {
            this.feedbackType = 'Screening';
            this.feedbackTypeLabel = 'Screening Feedback for';
            this.getCandidateProfile(function () {
                _this.showAdditionalCandidateDetailsFlag = true;
            });
        }
        else {
            if (this.feedbackType == 'Interview') {
                this.feedbackTypeLabel = 'Interview Feedback for';
                this.noEditableMeetingsLabel = "No 'Interviews' available for Feedback !";
            }
            else if (this.feedbackType == 'PhoneScreen') {
                this.feedbackTypeLabel = 'Phone Screen Feedback for';
                this.noEditableMeetingsLabel = "No 'Phone Screens' available for Feedback !";
            }
            else if (this.feedbackType == 'Outreach') {
                this.feedbackTypeLabel = 'Outreach Feedback for';
            }
            else {
                this.feedbackTypeLabel = 'Screening Feedback for';
                this.getCandidateProfile(function () {
                    _this.showAdditionalCandidateDetailsFlag = true;
                });
            }
        }
    };
    FeedbackExecutionController.prototype._massageMeetingDetails = function (data, refreshFlag) {
        var _this = this;
        this._setMeetingsList(data);
        // if a user id was passed in to the directive
        if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
            if (_.isUndefined(refreshFlag) || !refreshFlag) {
                // if it is not refresh mode
                if (!_.isUndefined(this.feedbackUserIdsList) && this.feedbackUserIdsList.length > 0) {
                    // if feedbackUserIdsList is not undefined / not passed in
                    this.feedbackUserIdsList = JSON.parse(this.feedbackUserIdsList);
                }
            }
            var meetings = _.filter(this.meetingsList, function (meeting) {
                return meeting.meetingScheduleId == _this.parentScheduleId;
            });
            this.meetingsList = angular.copy(meetings);
            this.chosenMeeting = this.meetingsList[0];
            this.loadingFeedbackOptionsFlag = false;
            this.feedbackEntityChanged();
        }
        else if (this.meetingsList.length == 1) {
            this.loadingFeedbackOptionsFlag = false;
            this.chosenMeeting = this.meetingsList[0];
            this.feedbackEntityChanged();
        }
        else {
            this.loadingFeedbackOptionsFlag = false;
        }
        this.showMeetingsFlag = true;
        // there exist multiple meetings and refresh flag is true
        if (this.meetingsList.length > 1 && !_.isUndefined(refreshFlag) && refreshFlag) {
            this.$timeout(function () {
                $('#chosenMeeting-' + _this.chosenMeeting.id).prop("checked", true);
            }, 500);
            // reload the feedback data
            this.feedbackEntityChanged();
        }
    };
    FeedbackExecutionController.prototype.getCandidateProfile = function (successCallback) {
        var _this = this;
        this.candidateService.getCandidateProfile(this.candidateId, false, function (data) {
            _this.candidateAdditionalDetails = data.candidateAdditionalDetails;
            if (_.isNull(_this.candidateAdditionalDetails)) {
                _this.candidateAdditionalDetails = new CandidateAdditionalDetails();
            }
            _this.candidateAdditionalDetails.candidateId = _this.candidateId;
            _this.savedCandidateAdditionalDetails = angular.copy(_this.candidateAdditionalDetails);
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    FeedbackExecutionController.prototype.checkRecruiterScreeningStatus = function () {
        var _this = this;
        this.screeningFeedbackStartedData = null;
        var userIdToCheckScreeningStatus = _.isNull(this.userId) ? this.loggedInUserId : this.userId;
        this.feedbackExecutionService.checkRecruiterScreeningStatus(this.jobMatchId, userIdToCheckScreeningStatus, this.companyId, function (data) {
            if (data.status == 'STARTED') {
                _this.screeningFeedbackStartedData = data;
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    FeedbackExecutionController.prototype.feedbackEntityChanged = function () {
        // reset question counts
        this.totalClQnsCount = 0;
        this.totalCount = 0;
        this.showMeetingLink = false;
        if (this.feedbackType == 'Screening') {
            this.userGetRecruiterQns = this.chosenUser.id;
            this._setUserAccessToFeedback(this.chosenUser.employer.id);
            if (this.candidateJobMatch.jobMatchCurrentState == 'Activated') {
                this.completeButtonLabel = 'Update';
            }
            else {
                this.completeButtonLabel = 'Complete';
            }
        }
        else {
            // as of now, choose the first user in the list of users on the meeting.
            this.userGetRecruiterQns = this.chosenMeeting.userList[0].userId;
            this._setUserAccessToFeedback(this.chosenMeeting.userList[0].companyId);
            // this.parentScheduleId = this.chosenMeeting.meetingScheduleId;
            if (this.chosenMeeting.status == 'COMPLETED') {
                this.completeButtonLabel = 'Update';
                this.showMeetingLink = false;
            }
            else {
                this.completeButtonLabel = 'Complete';
                if (this.chosenMeeting.meetingMode !== null && this.context !== 'conference') {
                    this.showMeetingLink = true;
                    var workflowStep = this.feedbackType == 'Interview' ? 'in' : 'ps';
                    this.chosenMeeting.meetingUrl = this.meetingService.getMeetingUrl(this.chosenMeeting.id, workflowStep, this.chosenMeeting.meetingMode);
                }
                else {
                    this.showMeetingLink = false;
                }
            }
        }
        this.getRecruiterQuestions();
    };
    FeedbackExecutionController.prototype._setUserAccessToFeedback = function (participantCompanyId) {
        if (!this.loginRequired) {
            this.userHasAccessToFeedback = true;
        }
        else {
            this.userHasAccessToFeedback = this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || this._isUserOfSameCompany(participantCompanyId) || this.feedbackType !== 'Screening';
        }
    };
    FeedbackExecutionController.prototype._isUserOfSameCompany = function (participantCompanyId) {
        return this.candidateJobMatch.jobMatchCompanyId == null || participantCompanyId == this.candidateJobMatch.jobMatchCompanyId;
    };
    FeedbackExecutionController.prototype.getCandidateJobMatchCardInfo = function (refreshFlag, successCallback) {
        var _this = this;
        if (!_.isUndefined(refreshFlag) && refreshFlag) {
            if (successCallback) {
                successCallback();
            }
        }
        else {
            var loggedInUserId = void 0;
            if (!this.loginRequired) {
                loggedInUserId = this.loggedInUserId;
            }
            this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, function (data) {
                data.name = data.firstName + ' ' + data.lastName;
                angular.merge(_this.candidateJobMatch, data);
                _this._checkIfContactDetailsMissing();
                if (successCallback) {
                    successCallback();
                }
            }, function (error) {
                if (_this.$rootScope.isOnline) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                }
            }, loggedInUserId);
        }
    };
    FeedbackExecutionController.prototype.getUserList = function (successCallback, errorCallback) {
        var _this = this;
        this.feedbackExecutionService.getUserList(this.jobMatchId, this.companyId, function (data) {
            _this.userList = angular.copy(data);
            _this.displayRecruiterName = true;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            if (errorCallback) {
                errorCallback();
            }
        });
    };
    FeedbackExecutionController.prototype._setMeetingsList = function (response) {
        var _this = this;
        this.meetingsList = [];
        var workflowStep = this.feedbackType == 'Interview' ? 'in' : 'ps';
        angular.forEach(response, function (meetingDetails, key) {
            var meeting = {};
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.meetingScheduleId = meetingDetails.meetingScheduleId;
            meeting.meetingMode = meetingDetails.meetingMode;
            meeting.meetingUrl = _this.meetingService.getMeetingUrl(meeting.id, workflowStep, meeting.meetingMode);
            //let currentDateTime = new Date();
            var startDateTime = new Date(meetingDetails.meetingStartTime);
            var endDateTime = new Date(meetingDetails.meetingEndTime);
            switch (meeting.status) {
                case 'SCHEDULED':
                case 'ACTIVE':
                    meeting.statusClass = 'fa fa-calendar feedback-meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    _this.editableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fa fa-hourglass-half feedback-meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = true;
                    _this.editableMeetingsExistFlag = true;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check feedback-meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = true;
                    _this.editableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'fas fa-clock feedback-meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    _this.editableMeetingsExistFlag = true;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban feedback-meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    // set defaults
                    meeting.statusClass = 'fa fa-question feedback-meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }
            switch (meeting.meetingMode) {
                case 'VIDEO':
                    meeting.meetingModeClass = 'fas fa-video';
                    break;
                case 'AUDIO':
                    meeting.meetingModeClass = 'fas fa-microphone';
                    break;
                case 'PHONE':
                    meeting.meetingModeClass = 'fas fa-phone';
                    break;
                case 'FACE_TO_FACE':
                    meeting.meetingModeClass = 'fas fa-user-friends';
                    break;
                default:
                    meeting.meetingModeClass = 'd-none';
                    break;
            }
            meeting.scheduledTime = moment(startDateTime).format("MMM DD, YYYY ( hh:mm a") + ' to ' + moment(endDateTime).format("hh:mm a )");
            meeting.userList = [];
            meeting.userNamesLabel = '';
            angular.forEach(meetingDetails.participants, function (meetingUser, k) {
                var user = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                user.isPoc = meetingUser.isPoc;
                user.companyId = meetingUser.company.id;
                meeting.userList.push(user);
                if (_this.candidateJobMatch.isSharedRequisition && !_this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                }
                else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            // meeting.label = user.userName + ' - ' + meeting.scheduledTime;
            _this.meetingsList.push(meeting);
        });
    };
    FeedbackExecutionController.prototype.getRecruiterQuestions = function (successCallback) {
        var _this = this;
        this.loadingFeedbackDetailsFlag = true;
        var meetingScheduleId = this.feedbackType == 'Screening' ? null : this.chosenMeeting.meetingScheduleId;
        var loggedInUserId = null;
        if (!this.loginRequired) {
            loggedInUserId = this.loggedInUserId;
        }
        this.feedbackExecutionService.getRecruiterQuestions(this.jobMatchId, this.userGetRecruiterQns, this.companyId, meetingScheduleId, loggedInUserId, function (data) {
            _this.loadingFeedbackDetailsFlag = false;
            _this.recruiterqns = angular.copy(data);
            _this.recruiterqns.readOnly = true;
            if (_this.context !== 'conference') {
                _this.feedbackReadOnly = _this.recruiterqns.readOnly;
            }
            _this.candidateId = data.candidate.id;
            _this.feedbackQuestionsCompanyId = null;
            angular.forEach(_this.recruiterqns.companyQuestionsResults, function (val, key) {
                _this.feedbackQuestionsCompanyId = key;
            });
            angular.forEach(_this.recruiterqns.jobDetails, function (job, key) {
                if (!_.isNull(job.assignedRecruiterName)) {
                    var index = job.recruiterNames.findIndex(function (name) {
                        return name == job.assignedRecruiterName;
                    });
                    if (index !== -1) {
                        job.recruiterNames.splice(index, 1);
                    }
                }
                if (_this.feedbackType == 'Screening' && !job.feedbackSavedBefore) {
                    job.interested = null;
                }
            });
            // create random ids for questions that do not have ids
            // company questions
            angular.forEach(_this.recruiterqns.companyQuestionsResults[_this.feedbackQuestionsCompanyId], function (val, key) {
                if (_.isNull(val.id)) {
                    val.id = Math.floor((Math.random() * 100) + 1).toString();
                    val.randomIdCreatedFlag = true;
                    val.showComment = true;
                }
            });
            // client questions
            angular.forEach(_this.recruiterqns.clientQuestionsResults, function (clientVal, clientKey) {
                angular.forEach(clientVal, function (val, key) {
                    if (_.isNull(val.id)) {
                        val.id = Math.floor((Math.random() * 100) + 1).toString();
                        val.randomIdCreatedFlag = true;
                        val.showComment = true;
                    }
                });
            });
            if (_this.recruiterqns.sortedClientList.length == 0) {
                _this.clientOrBuExists = false;
            }
            _this.displayQuestions = true;
            for (var key in _this.recruiterqns.jobDetails) {
                var jobDetailval = _this.recruiterqns.jobDetails[key];
                _this.type = jobDetailval.feedbackType;
                break;
            }
            if (_this.type != 'R') {
                _this.showInterested = false;
            }
            _this.savedRecruiterQns = angular.copy(_this.recruiterqns);
            _this.checkifCompanyCompleted();
            _this.initializeSliders();
            // Ensure bulk-formalize receives the current items once recruiter questions are loaded
            try {
                _this.formalizeItemsArray = _this._getAllItemsArray();
            }
            catch (e) {
                _this.formalizeItemsArray = [];
            }
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.loadingFeedbackDetailsFlag = false;
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    FeedbackExecutionController.prototype.getCompanyClass = function () {
        if (this.companyQnsComplete)
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    };
    FeedbackExecutionController.prototype.getClientClass = function () {
        if (this.checkifClientCompleted(keyval))
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    };
    FeedbackExecutionController.prototype.getJobClass = function () {
        if (this.checkifJobCompleted(keyval))
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    };
    FeedbackExecutionController.prototype.getOverallClass = function () {
        if (this.checkifCompanyOverallCompleted())
            return "panel-collapse collapse";
        else
            return "panel-collapse collapse in";
    };
    FeedbackExecutionController.prototype.setClientJobCompleted = function () {
        for (var clientId in this.recruiterqns.clientListJobMatchDetails) {
            var jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
            for (var i = 0; i < jobArray.length; i++) {
                var jobId = jobArray[i];
                // commenting the 'checkifJobCompleted' and including just checkIfClientCompleted for now as job questions are not involved.
                // checkifClientCompleted(clientId) && checkifJobCompleted(jobId)
                if (this.checkifClientCompleted(clientId)) {
                    this.recruiterqns.jobDetails[jobId].completed = true;
                }
                else {
                    this.recruiterqns.jobDetails[jobId].completed = false;
                }
            }
        }
    };
    FeedbackExecutionController.prototype.setNonClientJobsAsCompletedIfCompleted = function () {
        angular.forEach(this.recruiterqns.jobDetails, function (val, key) {
            if (_.isNull(val.clientName) && val.interested) {
                // if client Name is null, it means the job does not belong to any client - which can happen in case of corporation as BU is not mandatory.
                // if the job has been marked as interested, it means it can be marked as completed as there are no further questions to answer.
                val.completed = true;
            }
        });
    };
    FeedbackExecutionController.prototype.checkifCompanyCompleted = function () {
        this.isCompanyQuestionExists = false;
        if (this.recruiterqns === undefined || this.recruiterqns == '') {
            this.companyQnsComplete = false;
            return false;
        }
        var companykey;
        for (var key in this.recruiterqns.companyQuestionsResults) {
            companykey = key;
        }
        var companyQuestion = this.recruiterqns.companyQuestionsResults[companykey];
        if (companyQuestion != null) {
            for (var i = 0; i < companyQuestion.length; i++) {
                var recruiterComment = companyQuestion[i].recruiterComment;
                var overallQuestion = companyQuestion[i].question;
                var sliderId = companyQuestion[i].rating;
                if (overallQuestion != 'Overall Comment') {
                    this.isCompanyQuestionExists = true;
                    if (this.isEmpty(recruiterComment) && sliderId == "0") {
                        this.companyQnsComplete = false;
                        return false;
                    }
                }
            }
        }
        return true;
    };
    FeedbackExecutionController.prototype.checkifAllClientCompleted = function () {
        for (var key in this.recruiterqns.clientQuestionsResults) {
            var clientQuestion = this.recruiterqns.clientQuestionsResults[key];
            if (this.clientNotInterestedList.indexOf(key) > -1) {
                continue;
            }
            if (clientQuestion != null) {
                for (var i = 0; i < clientQuestion.length; i++) {
                    var recruiterComment = clientQuestion[i].recruiterComment;
                    var sliderId = clientQuestion[i].rating;
                    if (this.isEmpty(recruiterComment) && sliderId == "0") {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    FeedbackExecutionController.prototype.checkifClientCompleted = function (key) {
        var clientQuestion = this.recruiterqns.clientQuestionsResults[key];
        if (clientQuestion && clientQuestion.length > 0) {
            for (var i = 0; i < clientQuestion.length; i++) {
                var recruiterComment = clientQuestion[i].recruiterComment;
                var sliderId = clientQuestion[i].rating;
                if (this.isEmpty(recruiterComment) && sliderId == "0") {
                    return false;
                }
            }
            return true;
        }
        else {
            return true;
        }
    };
    FeedbackExecutionController.prototype.checkifJobCompleted = function (key) {
        var jobQuestion = this.recruiterqns.jobQuestionsResults[key];
        for (var i = 0; i < jobQuestion.length; i++) {
            var recruiterComment = jobQuestion[i].recruiterComment;
            var sliderId = jobQuestion[i].rating;
            if (this.isEmpty(recruiterComment) && sliderId == "0") {
                return false;
            }
        }
        return true;
    };
    FeedbackExecutionController.prototype.checkifAllJobCompleted = function () {
        for (var key in this.recruiterqns.jobQuestionsResults) {
            var jobQuestion = this.recruiterqns.jobQuestionsResults[key];
            if (this.jobNotInterestedList.indexOf(key) > -1) {
                continue;
            }
            for (var i = 0; i < jobQuestion.length; i++) {
                var recruiterComment = jobQuestion[i].recruiterComment;
                var sliderId = jobQuestion[i].rating;
                if (this.isEmpty(recruiterComment) && sliderId == "0") {
                    return false;
                }
            }
        }
        return true;
    };
    FeedbackExecutionController.prototype.checkifCompanyOverallCompleted = function () {
        if (this.recruiterqns === undefined || this.recruiterqns == '')
            return true;
        var companykey;
        if (this.recruiterqns != null && this.recruiterqns.companyQuestionsResults != null) {
            for (var key in this.recruiterqns.companyQuestionsResults) {
                companykey = key;
            }
            var companyQuestion = this.recruiterqns.companyQuestionsResults[companykey];
            if (companyQuestion != null) {
                for (var i = 0; i < companyQuestion.length; i++) {
                    var recruiterComment = companyQuestion[i].recruiterComment;
                    var overallQuestion = companyQuestion[i].question;
                    var sliderId = companyQuestion[i].rating;
                    if (overallQuestion == 'Overall Comment') {
                        if (this.isEmpty(recruiterComment) && sliderId == "0") {
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    };
    FeedbackExecutionController.prototype.countJobQns = function () {
        return this.totalCount++;
    };
    FeedbackExecutionController.prototype.countClientQns = function () {
        return this.totalClQnsCount++;
    };
    FeedbackExecutionController.prototype.isEmpty = function (str) {
        return (!str || 0 === str.trim().length);
    };
    FeedbackExecutionController.prototype.initializeSliders = function () {
        var _this = this;
        this.$timeout(function () {
            _this.initCoSliders();
            _this.initClSliders();
            _this.initJobSliders();
            $("div[class='overall-qn-slider']").each(function (i, obj) {
                var questionId = obj.id.split('__')[1];
                var questionIndex = _this.getQuestionIndex('Company', _this.feedbackQuestionsCompanyId, 'id', questionId);
                var labelId = "overall-qn-rating__" + questionId;
                $(obj).noUiSlider({
                    range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                    slide: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                        _this.recruiterqns.companyQuestionsResults[_this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                    },
                    set: function () {
                        var val = $(obj).val();
                        $("#" + labelId).text(Math.round(val));
                        _this.recruiterqns.companyQuestionsResults[_this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                    }
                });
                // set the initial value
                $(obj).val(_this.recruiterqns.companyQuestionsResults[_this.feedbackQuestionsCompanyId][questionIndex].rating, true);
            });
        }, 200);
    };
    FeedbackExecutionController.prototype.getQuestionIndex = function (questionType, questionTypeId, propName, propValue) {
        var questionIndex = 0;
        var questionsArray = [];
        if (questionType == 'Company') {
            questionsArray = this.recruiterqns.companyQuestionsResults[questionTypeId];
        }
        else if (questionType == 'Client') {
            questionsArray = this.recruiterqns.clientQuestionsResults[questionTypeId];
        }
        if (propName == 'id') {
            questionIndex = _.findIndex(questionsArray, { 'id': propValue });
        }
        else if (propName == 'question') {
            questionIndex = _.findIndex(questionsArray, { 'question': propValue });
        }
        return questionIndex;
    };
    FeedbackExecutionController.prototype.initCoSliders = function () {
        var _this = this;
        $("div[class='co-qn-slider']").each(function (i, obj) {
            var questionId = obj.id.split('__')[1];
            var questionIndex = _this.getQuestionIndex('Company', _this.feedbackQuestionsCompanyId, 'id', questionId);
            var labelId = "co-qn-rating__" + questionId;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: function () {
                    var val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    _this.recruiterqns.companyQuestionsResults[_this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                },
                set: function () {
                    var val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    _this.recruiterqns.companyQuestionsResults[_this.feedbackQuestionsCompanyId][questionIndex].rating = parseInt(val);
                }
            });
            // set the initial value
            $(obj).val(_this.recruiterqns.companyQuestionsResults[_this.feedbackQuestionsCompanyId][questionIndex].rating, true);
        });
    };
    FeedbackExecutionController.prototype.initClSliders = function () {
        var _this = this;
        $("div[class='cl-qn-slider']").each(function (i, obj) {
            var clientId = obj.id.split('__')[1];
            var questionId = obj.id.split('__')[2];
            var questionIndex = _this.getQuestionIndex('Client', clientId, 'id', questionId);
            var labelId = "cl-qn-rating__" + clientId + '__' + questionId;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: function () {
                    var val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    _this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating = parseInt(val);
                },
                set: function () {
                    var val = $(obj).val();
                    $("#" + labelId).text(Math.round(val));
                    _this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating = parseInt(val);
                }
            });
            // set the initial value
            $(obj).val(_this.recruiterqns.clientQuestionsResults[clientId][questionIndex].rating, true);
        });
    };
    FeedbackExecutionController.prototype.initJobSliders = function () {
        $("div[id='job-qn-slider']").each(function (i, obj) {
            var labelId = "#job-qn-rating" + ++i;
            $(obj).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: function () {
                    var val = $(obj).val();
                    $(labelId).text(Math.round(val));
                },
                set: function () {
                    var val = $(obj).val();
                    $(labelId).text(Math.round(val));
                }
            });
            var qnRating = $(labelId).text();
            $(obj).val(qnRating, true);
        });
    };
    FeedbackExecutionController.prototype.filterFunction = function (element) {
        return element.question.match(/^Overall/) ? false : true;
    };
    FeedbackExecutionController.prototype.filterFunctionForOverall = function (element) {
        if (element != null) {
            return element.question.match(/^Overall/) ? true : false;
        }
    };
    FeedbackExecutionController.prototype.clearObjects = function () {
        this.recruiterqns = "";
    };
    FeedbackExecutionController.prototype.filterByInterested = function () {
        if (this.clientOrBuExists && this.feedbackType != 'Outreach') {
            for (var clientId in this.recruiterqns.clientListJobMatchDetails) {
                var showClient = false;
                var jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
                for (var i = 0; i < jobArray.length; i++) {
                    var jobId = jobArray[i];
                    // commenting as job questions are not involved right now
                    // let x = document.getElementById(jobId);
                    if (this.recruiterqns.jobDetails[jobId].interested) {
                        // commenting as job questions are not involved right now
                        // x.style.display = "block";
                        showClient = true;
                    }
                    else {
                        // commenting as job questions are not involved right now
                        // x.style.display = "none";
                    }
                    var y = document.getElementById(clientId);
                    if (showClient) {
                        y.style.display = "block";
                    }
                    else {
                        y.style.display = "none";
                    }
                }
            }
        }
    };
    FeedbackExecutionController.prototype.toDisplayJobPanel = function (jobMatchId) {
        var jobQuestionList = this.recruiterqns.jobQuestionsResults[jobMatchId];
        if (jobQuestionList == null || jobQuestionList.length == 0) {
            return false;
        }
        else {
            return true;
        }
    };
    FeedbackExecutionController.prototype.toDisplayClientPanel = function (clientKey) {
        var clientQuestionList = this.recruiterqns.clientQuestionsResults[clientKey];
        if (clientQuestionList == null) {
            return false;
        }
        else {
            return true;
        }
    };
    FeedbackExecutionController.prototype.isClientJobEnabled = function (clientId) {
        var _this = this;
        var jobArray = this.recruiterqns.clientListJobMatchDetails[clientId];
        var isClientJobEnabledFlag = false;
        angular.forEach(jobArray, function (jobId, key) {
            if (_this.recruiterqns.jobDetails[jobId].interested) {
                isClientJobEnabledFlag = true;
            }
        });
        return isClientJobEnabledFlag;
    };
    FeedbackExecutionController.prototype.closeModal = function () {
        if (!_.isUndefined(this.completeFeedbackCallback)) {
            this.completeFeedbackCallback();
        }
    };
    FeedbackExecutionController.prototype._checkIfContactDetailsMissing = function () {
        var candidateJobMatch = _.cloneDeep(this.candidateJobMatch);
        candidateJobMatch.candidateAdditionalDetails.workLocations = this.candidateJobMatch.workLocations;
        this.isCandidateContactDetailsMissing = !this.sharedService.isContactDetailsAvailable(candidateJobMatch, 'candidateJobMatchCard');
        this.isCandidateContactAdditionalDetailsMissing = !this.sharedService.isCandidateAdditionalDetailsAvailable(candidateJobMatch);
        if (this.isCandidateContactAdditionalDetailsMissing) {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback({ result: true });
            }
        }
        else {
            if (this.candidateContactDetailsMissingCallback) {
                this.candidateContactDetailsMissingCallback({ result: false });
            }
        }
    };
    FeedbackExecutionController.prototype._setCandidateMissingDetailsMessage = function (contactDetails, additionalDetails) {
        var message = [];
        if (contactDetails) {
            if (!this.candidateJobMatch.email)
                message.push('Email');
            if (!this.candidateJobMatch.mobilephone)
                message.push('Phone Number');
            if ((!this.candidateJobMatch.address || (!this.candidateJobMatch.address.zipcode || this.candidateJobMatch.address.zipcode == "")))
                message.push('Zip code');
        }
        if (additionalDetails) {
            if (!this.candidateJobMatch.candidateAdditionalDetails) {
                message.push('Preferred JobType', 'Salary', 'Work Authorization', 'Work Location');
            }
            else {
                if (!this.candidateJobMatch.candidateAdditionalDetails.preferredJobTypeDetails || this.candidateJobMatch.candidateAdditionalDetails.preferredJobTypeDetails.jobType.length === 0)
                    message.push('Preferred JobType', 'Salary');
                if (!this.candidateJobMatch.candidateAdditionalDetails.sponsorships || this.candidateJobMatch.candidateAdditionalDetails.sponsorships.length === 0)
                    message.push('Work Authorization');
                if (!this.candidateJobMatch.workLocations || this.candidateJobMatch.workLocations.length === 0)
                    message.push('Work Locations');
            }
        }
        return message.toString().replaceAll(",", ", ");
    };
    FeedbackExecutionController.prototype._checkCandidateMissingInfo = function (successCallback, cancelCallback) {
        var _this = this;
        var contactMissingInfoMessage = this._setCandidateMissingDetailsMessage(this.isCandidateContactDetailsMissing, this.isCandidateContactAdditionalDetailsMissing);
        var title = "Missing Information";
        var message = "<div>\n                            <p>The useful information of the candidate <span>'<span class=\"emerald\">" + contactMissingInfoMessage + "</span>'</span> is missing and needs to be entered.<p>\n                            <p>Complete anyway?</p>\n                        </div>";
        this.alertsAndNotificationsService.showConfirm(title, message, 'warning', true, function () {
            if (successCallback) {
                successCallback();
            }
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, function () {
            if (cancelCallback) {
                cancelCallback();
            }
            _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
    };
    FeedbackExecutionController.prototype.completeModal = function (fromButton) {
        this.saveResults(fromButton);
        /* setTimeout(() =>  {
           if(!_.isUndefined(this.completeFeedbackCallback)){
                 this.completeFeedbackCallback();
             }
         }, 5000);*/
    };
    FeedbackExecutionController.prototype.cancelModal = function () {
        var _this = this;
        var showConfirmationPopup = false;
        if (!angular.equals(this.savedRecruiterQns, this.recruiterqns) || !angular.equals(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails)) {
            showConfirmationPopup = true;
        }
        if (showConfirmationPopup) {
            bootbox.hideAll();
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Unsaved data on the page will be lost.<br><br> Do you still want to continue?",
                className: "zIndex1060",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        if (!_.isUndefined(_this.closeModal)) {
                            _this.closeModal();
                        }
                    }
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
        else {
            if (!_.isUndefined(this.closeModal)) {
                this.closeModal();
            }
        }
    };
    FeedbackExecutionController.prototype.addQuestion = function (category, categoryId) {
        var _this = this;
        var sliderIdPrefix = '';
        var sliderTextIdPrefix = '';
        var ratingId = '';
        var newQuestion = {};
        if (category == 'Company') {
            newQuestion = this._createDuplicateQuestion(this.recruiterqns.companyQuestionsResults[categoryId][0], categoryId, 'company');
            this.recruiterqns.companyQuestionsResults[categoryId].push(newQuestion);
            sliderIdPrefix = 'co-qn-slider';
            sliderTextIdPrefix = 'co-qn-rating';
        }
        else if (category == 'Client') {
            newQuestion = this._createDuplicateQuestion(this.recruiterqns.clientQuestionsResults[categoryId][0], categoryId, 'clientOrBu');
            this.recruiterqns.clientQuestionsResults[categoryId].push(newQuestion);
            sliderIdPrefix = 'cl-qn-slider__' + categoryId;
            sliderTextIdPrefix = 'cl-qn-rating__' + categoryId;
        }
        this.$timeout(function () {
            var questionIndex = _this.getQuestionIndex(category, categoryId, 'id', newQuestion.id);
            $('#' + sliderIdPrefix + '__' + newQuestion.id).noUiSlider({
                range: [0, 10], start: [0], step: 1, handles: 1, connect: 'lower',
                slide: function () {
                    var val = $('#' + sliderIdPrefix + '__' + newQuestion.id).val();
                    $("#" + sliderTextIdPrefix + "__" + newQuestion.id).text(Math.round(val));
                    if (category == 'Company') {
                        _this.recruiterqns.companyQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                    else {
                        _this.recruiterqns.clientQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                },
                set: function () {
                    var val = $('#' + sliderIdPrefix + '__' + newQuestion.id).val();
                    $("#" + sliderTextIdPrefix + "__" + newQuestion.id).text(Math.round(val));
                    if (category == 'Company') {
                        _this.recruiterqns.companyQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                    else {
                        _this.recruiterqns.clientQuestionsResults[categoryId][questionIndex].rating = parseInt(val);
                    }
                }
            });
            $('#' + sliderIdPrefix + '__' + newQuestion.id).val(0, true);
        }, 200);
    };
    FeedbackExecutionController.prototype.removeQuestion = function (category, categoryId, questionId) {
        var questionsArray = [];
        if (category == 'Company') {
            questionsArray = this.recruiterqns.companyQuestionsResults[categoryId];
        }
        else if (category == 'Client') {
            questionsArray = this.recruiterqns.clientQuestionsResults[categoryId];
        }
        var questionIndex = this.getQuestionIndex(category, categoryId, 'id', questionId);
        questionsArray.splice(questionIndex, 1);
    };
    FeedbackExecutionController.prototype._createDuplicateQuestion = function (question, companyClientOrBuId, companyType) {
        var questionDuplicate = {};
        if (!_.isUndefined(question)) {
            questionDuplicate = angular.copy(question);
        }
        // set the variables to defaults
        questionDuplicate.question = "";
        questionDuplicate.rating = 0;
        questionDuplicate.recruiterComment = null;
        questionDuplicate.questionareDateTime = null;
        questionDuplicate.userId = null;
        // create a temporary Id
        questionDuplicate.id = Math.floor((Math.random() * 100) + 1).toString();
        questionDuplicate.recruiterName = null;
        questionDuplicate.questionType = null;
        questionDuplicate.lastModifiedBy = null;
        questionDuplicate.participantId = null;
        questionDuplicate.jobmatchId = null;
        questionDuplicate.newQuestionFlag = true;
        questionDuplicate.candidateId = this.candidateId;
        if (companyType == 'clientOrBu') {
            questionDuplicate.clientorbuId = companyClientOrBuId;
            questionDuplicate.companyId = this.companyId;
            questionDuplicate.externalComment = null;
            questionDuplicate.questionOrder = 0;
        }
        return questionDuplicate;
    };
    FeedbackExecutionController.prototype.saveResults = function (fromButton, successCallback) {
        var _this = this;
        if (fromButton == "save" && this.feedbackType == 'Screening') {
            var feedbackSaveNeeded = !angular.equals(this.savedRecruiterQns, this.recruiterqns);
            var candidateAdditionalDetailsSaveNeeded = !angular.equals(this.savedCandidateAdditionalDetails, this.candidateAdditionalDetails);
            var hasUnselectedJobs = this._hasUnSelectedJobs();
            if (hasUnselectedJobs) {
                this._showUnSelectedJobsModal();
            }
            else if (!feedbackSaveNeeded && !candidateAdditionalDetailsSaveNeeded) {
                // show no data to save modal only when it is in save mode
                this._showNoDataToSaveModal();
            }
            else if (feedbackSaveNeeded && candidateAdditionalDetailsSaveNeeded) {
                this._saveFeedback(fromButton, function () {
                    _this._saveCandidateAdditionalDetails(false);
                });
            }
            else if (feedbackSaveNeeded) {
                this._saveFeedback(fromButton);
            }
            else if (candidateAdditionalDetailsSaveNeeded) {
                this._saveCandidateAdditionalDetails(true);
            }
        }
        else if (fromButton == "save" && this.feedbackType !== 'Screening') {
            if (!this._hasFeedbackChanged()) {
                // show no data to save modal only when it is in save mode
                this._showNoDataToSaveModal();
            }
            else {
                this._saveFeedback(fromButton);
            }
        }
        else if (fromButton === 'complete' && this.feedbackType == 'Screening') {
            if (this._hasUnSelectedJobs()) {
                this._showUnSelectedJobsModal();
            }
            else {
                this._checkIfContactDetailsMissing();
                if (this.completeButtonLabel != 'Update' && (this.isCandidateContactDetailsMissing || this.isCandidateContactAdditionalDetailsMissing)) {
                    this._checkCandidateMissingInfo(function () {
                        _this._saveFeedback(fromButton, function () {
                            if (!angular.equals(_this.savedCandidateAdditionalDetails, _this.candidateAdditionalDetails)) {
                                _this._saveCandidateAdditionalDetails(false);
                            }
                        });
                    }, function () {
                        if (_this._hasFeedbackChanged()) {
                            _this._saveFeedback('save');
                        }
                    });
                }
                else {
                    this._saveFeedback(fromButton, function () {
                        if (!angular.equals(_this.savedCandidateAdditionalDetails, _this.candidateAdditionalDetails)) {
                            _this._saveCandidateAdditionalDetails(false);
                        }
                    });
                }
            }
        }
        else {
            this._checkIfContactDetailsMissing();
            if (this.completeButtonLabel != 'Update' && fromButton === 'complete' && (this.isCandidateContactDetailsMissing || this.isCandidateContactAdditionalDetailsMissing)) {
                this._checkCandidateMissingInfo(function () {
                    _this._saveFeedback(fromButton, function () {
                        if (!angular.equals(_this.savedCandidateAdditionalDetails, _this.candidateAdditionalDetails)) {
                            _this._saveCandidateAdditionalDetails(false);
                        }
                    });
                }, function () {
                    if (_this._hasFeedbackChanged()) {
                        _this._saveFeedback('save');
                    }
                });
            }
            else {
                this._saveFeedback(fromButton);
            }
        }
    };
    FeedbackExecutionController.prototype._hasUnSelectedJobs = function () {
        for (var jobId in this.recruiterqns.jobDetails) {
            if (this.feedbackType == 'Screening' && this.recruiterqns.jobDetails[jobId].interested == null) {
                return true;
            }
        }
        return false;
    };
    FeedbackExecutionController.prototype._hasFeedbackChanged = function () {
        return !angular.equals(this.savedRecruiterQns, this.recruiterqns);
    };
    FeedbackExecutionController.prototype._saveFeedback = function (fromButton, successCallback) {
        var _this = this;
        var statusOfSave;
        var listofCompanyQuestions;
        var listofClientQuestions = [];
        var listofJobQuestions = [];
        var overallCommentsQuestionIndex;
        var companyCompleted = true;
        var clientAllCompleted = true;
        var newQuestionErrorExistFlag = false;
        var joballCompleted = true;
        var participantId = '';
        var companyOverallCompleted = true;
        // populate the participant Id
        if (this.userList.length == 1) {
            participantId = this.userList[0].id;
        }
        else {
            participantId = this.userGetRecruiterQns;
        }
        if (this.recruiterqns != null) {
            angular.forEach(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId], function (val, key) {
                val.questionareDateTime = _this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                val.questionType = _this.type;
                val.lastModifiedBy = _.isNull(_this.userId) ? _this.loggedInUserId : _this.userId;
                val.participantId = participantId;
                if (val.question != 'Overall Comment') {
                    if (val.rating == "0" && _this.isEmpty(val.recruiterComment)) {
                        companyCompleted = false;
                    }
                    if (!_.isUndefined(val.newQuestionFlag) && val.question.trim() == "") {
                        newQuestionErrorExistFlag = true;
                    }
                }
                else if (val.question == 'Overall Comment') {
                    if (val.rating == "0" && _this.isEmpty(val.recruiterComment)) {
                        companyOverallCompleted = false;
                    }
                }
            });
            listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId];
            angular.forEach(this.recruiterqns.clientQuestionsResults, function (clientVal, clientKey) {
                if (_this.isClientJobEnabled(clientKey)) {
                    angular.forEach(clientVal, function (val, key) {
                        val.questionareDateTime = _this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        val.questionType = _this.type;
                        val.lastModifiedBy = _.isNull(_this.userId) ? _this.loggedInUserId : _this.userId;
                        val.participantId = participantId;
                        if (val.rating == "0" && _this.isEmpty(val.recruiterComment)) {
                            clientAllCompleted = false;
                        }
                        if (!_.isUndefined(val.newQuestionFlag) && val.question.trim() == "") {
                            newQuestionErrorExistFlag = true;
                        }
                    });
                    if (listofClientQuestions) {
                        listofClientQuestions = listofClientQuestions.concat(clientVal);
                    }
                    else {
                        listofClientQuestions = clientVal;
                    }
                }
            });
            var _loop_1 = function (key) {
                if (this_1.toDisplayJobPanel(key)) {
                    var spanId = "job-qn" + key;
                    $("span[id=" + spanId + "]").each(function (i, obj) {
                        var jobQnNoFldId = "job-qn-no" + key;
                        var jobQnNo = $("input[id=" + jobQnNoFldId + "]")[i].value;
                        var sliderId = "#job-qn-rating" + jobQnNo;
                        var textAreaId = "#job-qn-comments" + jobQnNo;
                        _this.recruiterqns.jobQuestionsResults[key][i]["rating"] = $(sliderId).text();
                        _this.recruiterqns.jobQuestionsResults[key][i]["recruiterComment"] = $(textAreaId).val();
                        _this.recruiterqns.jobQuestionsResults[key][i]["questionareDateTime"] = _this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        _this.recruiterqns.jobQuestionsResults[key][i]["questionType"] = _this.type;
                        _this.recruiterqns.jobQuestionsResults[key][i]["lastModifiedBy"] = _.isNull(_this.userId) ? _this.loggedInUserId : _this.userId;
                        _this.recruiterqns.jobQuestionsResults[key][i]["participantId"] = participantId;
                        if (_this.recruiterqns.jobQuestionsResults[key][i]["rating"] == "0" && _this.isEmpty(_this.recruiterqns.jobQuestionsResults[key][i]["recruiterComment"])) {
                            joballCompleted = false;
                        }
                    });
                    if (listofJobQuestions) {
                        listofJobQuestions = listofJobQuestions.concat(this_1.recruiterqns.jobQuestionsResults[key]);
                    }
                    else {
                        listofJobQuestions = this_1.recruiterqns.jobQuestionsResults[key];
                    }
                    var jobQuestionList = this_1.recruiterqns.jobQuestionsResults[key];
                    if (jobQuestionList == null || jobQuestionList.length == 0) {
                        joballCompleted = true;
                    }
                }
            };
            var this_1 = this;
            for (var key in this.recruiterqns.jobQuestionsResults) {
                _loop_1(key);
            }
            var listOfCompanyquest = listofCompanyQuestions ? listofCompanyQuestions.concat(listofClientQuestions) : [];
            // commenting for now as job questions are not involved now.
            //listOfQuestionsResults = listOfCompanyquest.concat(listofJobQuestions);
            var listOfQuestionsResults = listOfCompanyquest;
            this.setClientJobCompleted();
            this.setNonClientJobsAsCompletedIfCompleted();
            //  this.feedbackExecutionResult = new FeedbackExecutionResult();
            if (companyCompleted && clientAllCompleted && companyOverallCompleted) {
                this.feedbackExecutionResult.companyAndOverallComplete = "complete";
            }
            else {
                this.feedbackExecutionResult.companyAndOverallComplete = "notcomplete";
            }
            var listOfjobdetails = [];
            for (var key in this.recruiterqns.jobDetails) {
                listOfjobdetails.push(this.recruiterqns.jobDetails[key]);
            }
            this.feedbackExecutionResult.companyId = this.companyId;
            this.feedbackExecutionResult.feedbackAnswersList = listOfQuestionsResults;
            this.feedbackExecutionResult.jobDetailsRecruiterScreeningList = listOfjobdetails;
            this.feedbackExecutionResult.fromButton = fromButton;
            this.feedbackExecutionResult.meetingScheduleId = this.feedbackType == 'Screening' ? null : this.chosenMeeting.meetingScheduleId;
            this.feedbackExecutionResult.externalMeetingId = this.feedbackType == 'Screening' && !this.externalMeetingCallId ? null : this.externalMeetingCallId;
            // validation before save
            if (newQuestionErrorExistFlag) {
                // new questions added but no question value is given
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Question not provided!</strong></div>",
                    message: "Question cannot be empty. <br>Please provide a question and its rating for all the new questions added.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: function () {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
            else if (fromButton === 'complete' && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
                // complete / update is clicked and all the questions are not answered
                var message = "Please answer all the questions to complete the feedback form.";
                if (this.completeButtonLabel == 'Update') {
                    message = "Please answer all the questions to update the feedback form.";
                }
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Incomplete Form!</strong></div>",
                    message: message,
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: function () {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
            else if (((this.feedbackType == 'Screening' && this.candidateJobMatch.jobMatchCurrentState == 'Activated') || ((this.feedbackType == 'Interview' || this.feedbackType == 'PhoneScreen') && this.chosenMeeting.status == 'COMPLETED')) && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
                // save is clicked for recruiter screening for a job match that is in activated state (meaning completion).
                // or
                // save is clicked for an interview or phone screen that is already completed
                // and
                // all questions are not answered.
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Incomplete Form!</strong></div>",
                    message: "You are saving a Completed Feedback form. Please answer all the questions.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: function () {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
            else {
                if (fromButton == 'save') {
                    $("#cancelBtn").prop("disabled", true);
                    $("#completeBtn").prop("disabled", true);
                    this.savingFlag = true;
                }
                else if (fromButton == 'complete') {
                    $("#cancelBtn").prop("disabled", true);
                    $("#saveBtn").prop("disabled", true);
                    this.completingFlag = true;
                }
                // remove newQuestionFlag or randomIdCreatedFlag and temporary id on new questions
                angular.forEach(this.feedbackExecutionResult.feedbackAnswersList, function (val, key) {
                    if (!_.isUndefined(val.newQuestionFlag)) {
                        // set the id to null
                        val.id = null;
                        // delete the new question flag.
                        delete val.newQuestionFlag;
                    }
                    else if (!_.isUndefined(val.randomIdCreatedFlag)) {
                        // set the id to null
                        val.id = null;
                        // delete the random id created flag.
                        delete val.randomIdCreatedFlag;
                    }
                });
                var loggedInUserId = null;
                if (!this.loginRequired) {
                    loggedInUserId = this.loggedInUserId;
                }
                this.feedbackExecutionService.saveRecruiterQuestions(angular.toJson(this.feedbackExecutionResult), this.jobMatchId, loggedInUserId, function (data) {
                    if (successCallback) {
                        successCallback();
                    }
                    if (fromButton == 'save') {
                        _this.savingFlag = false;
                        $("#cancelBtn").prop("disabled", false);
                        $("#completeBtn").prop("disabled", false);
                        if (!_.isUndefined(_this.saveCallback)) {
                            // call the save call back on save, if it is defined
                            _this.saveCallback();
                        }
                        // refresh the data on screen.
                        _this.init(true);
                    }
                    else if (fromButton == 'complete') {
                        var feedbackTypeLabel = 'Screening';
                        var completeTypeLabel = 'completed';
                        _this.completingFlag = false;
                        if (_this.feedbackType == 'Screening') {
                            if (_this.candidateJobMatch.jobMatchCurrentState == 'Activated') {
                                completeTypeLabel = 'updated';
                            }
                        }
                        else if (_this.feedbackType == 'Interview' || _this.feedbackType == 'PhoneScreen') {
                            feedbackTypeLabel = _this.feedbackType == 'Interview' ? 'Interview' : 'Phone Screen';
                            if (_this.chosenMeeting.status == 'COMPLETED') {
                                completeTypeLabel = 'updated';
                            }
                        }
                        var successMessage = 'The ' + feedbackTypeLabel + ' Feedback has been ' + completeTypeLabel + ' successfully.';
                        bootbox.alert({
                            closeButton: false,
                            title: "<div class='alert alert-success' style='margin-bottom: 0px;'><i class='fa fa-check fa-fw fa-lg'></i><strong>Success!</strong></div>",
                            message: successMessage,
                            className: "zIndex1060",
                            buttons: {
                                ok: {
                                    label: 'Ok',
                                    className: 'btn-info'
                                }
                            },
                            callback: function () {
                                if (!_.isUndefined(_this.completeFeedbackCallback)) {
                                    setTimeout(function () {
                                        _this.completeFeedbackCallback();
                                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                    }, 300);
                                }
                                else {
                                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                    // refresh the data on screen.
                                    _this.init(true);
                                }
                            }
                        });
                    }
                }, function (error) {
                    _this.savingFlag = false;
                    _this.completingFlag = false;
                    $("#cancelBtn").prop("disabled", false);
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
        }
    };
    FeedbackExecutionController.prototype._saveCandidateAdditionalDetails = function (isSuccessMessageNeeded) {
        var _this = this;
        this.candidateService.addOrUpdateCandidateAdditionalDetails(this.candidateAdditionalDetails, function (data) {
            if (isSuccessMessageNeeded) {
                _this.alertsAndNotificationsService.showBannerMessage(data.message, 'success');
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    FeedbackExecutionController.prototype._showUnSelectedJobsModal = function () {
        var _this = this;
        var message = "Some job matches have not been marked as Interested or Not Interested.";
        var isAllJobMatchesUnselected = true;
        for (var jobId in this.recruiterqns.jobDetails) {
            if (this.recruiterqns.jobDetails[jobId].interested !== null) {
                isAllJobMatchesUnselected = false;
                break;
            }
        }
        if (isAllJobMatchesUnselected) {
            message = "None of the job matches have been marked as Interested or Not Interested";
        }
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Alert!</strong></div>",
            message: message,
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    };
    FeedbackExecutionController.prototype._showNoDataToSaveModal = function () {
        var _this = this;
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Alert!</strong></div>",
            message: "Nothing to Save!",
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: function () {
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    };
    FeedbackExecutionController.prototype.markAllJobsAsInterested = function () {
        for (var jobId in this.recruiterqns.jobDetails) {
            this.recruiterqns.jobDetails[jobId].interested = true;
        }
        this.filterByInterested();
    };
    FeedbackExecutionController.prototype.onInternalNoteChanged = function () {
        var indexOfOverallQuestion = this._getIndexOfOverallQuestion();
        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].externalComment = this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].recruiterComment;
    };
    FeedbackExecutionController.prototype.onExternalNoteChange = function (event) {
        var indexOfOverallQuestion = this._getIndexOfOverallQuestion();
        this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId][indexOfOverallQuestion].externalComment = event.externalNote;
    };
    FeedbackExecutionController.prototype._getIndexOfOverallQuestion = function () {
        return this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId].findIndex(function (question) { return question.question == "Overall Comment"; });
    };
    FeedbackExecutionController.prototype.onCopyNoteChange = function (event) {
        this.copyNote = event.copyNote;
    };
    FeedbackExecutionController.prototype.openConference = function (meeting) {
        window.open(meeting.meetingUrl, "_blank");
    };
    FeedbackExecutionController.prototype.toggleCompanyQuestionComments = function () {
        var _this = this;
        this.showAllCompanyQuestionComments = !this.showAllCompanyQuestionComments;
        angular.forEach(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId], function (val, key) {
            val.showComment = _this.showAllCompanyQuestionComments;
        });
    };
    FeedbackExecutionController.prototype.toggleClientQuestionComments = function (clientId) {
        var _this = this;
        this.showAllClientQuestionComments = !this.showAllClientQuestionComments;
        angular.forEach(this.recruiterqns.clientQuestionsResults[clientId], function (val, key) {
            val.showComment = _this.showAllClientQuestionComments;
        });
    };
    FeedbackExecutionController.prototype.viewJobProfile = function (jobId) {
        var _this = this;
        // $(".modal").addClass("job-match-meetings-modal-large");
        $(".modal").addClass("job-match-meetings-modal-large");
        this.$timeout(function () {
            _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowTopClass: 'four-dot-five-modal-large',
                backdrop: 'static',
                keyboard: false,
                component: 'feedbackExecutionActionsModal',
                resolve: {
                    actionType: function () {
                        return 'jobProfile';
                    },
                    jobId: function () {
                        return jobId;
                    }
                }
            }).result.then(function (callback) {
                //do nothing
            }, function (dismiss) {
                _this.$timeout(function () {
                    $(".modal").removeClass("job-match-meetings-modal-large");
                }, 600);
            });
        }, 300);
    };
    FeedbackExecutionController.prototype.viewCandidateBooklet = function (meeting) {
        var _this = this;
        var meetingId = meeting ? meeting.id : this.parentScheduleId;
        var usersList = meeting ? meeting.userList : this.feedbackUserIdsList;
        $(".modal").addClass("job-match-meetings-modal-medium");
        this.$timeout(function () {
            _this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowTopClass: 'four-dot-five-modal-large',
                backdrop: 'static',
                keyboard: false,
                component: 'feedbackExecutionActionsModal',
                resolve: {
                    actionType: function () {
                        return 'candidateBooklet';
                    },
                    candidateId: function () {
                        return _this.candidateJobMatch.id;
                    },
                    jobId: function () {
                        return _this.candidateJobMatch.jobMatchJobId;
                    },
                    jobMatchId: function () {
                        return _this.jobMatchId;
                    },
                    feedbackType: function () {
                        return _this.feedbackType;
                    },
                    feedbackUserIdsList: function () {
                        return usersList;
                    },
                    scheduleId: function () {
                        return meetingId;
                    }
                }
            }).result.then(function (callback) {
                if (callback.callbackType == 'refresh') {
                    _this.completeFeedbackCallback();
                }
                _this.$timeout(function () {
                    $(".modal").removeClass("job-match-meetings-modal-medium");
                }, 600);
            }, function (dismiss) {
                _this.$timeout(function () {
                    $(".modal").removeClass("job-match-meetings-modal-large");
                }, 600);
            });
        }, 300);
    };
    FeedbackExecutionController.prototype.onUserWhoCanEditFeedbackChange = function () {
        var _this = this;
        this.enabledEditForUser = this.usersToEditFeedback.find(function (user) { return user.attendeeId == _this.enableEditForAttendeeId; });
        if (angular.equals(this.savedRecruiterQns, this.recruiterqns)) {
            this._confirmEnablingUserToEdit();
        }
        else {
            this._alertUserToSaveTheFeedback();
        }
    };
    FeedbackExecutionController.prototype._confirmEnablingUserToEdit = function () {
        var _this = this;
        var message = "Only '" + this.enabledEditForUser.displayName + "' will be allowed to edit the feedback.<br><br> Do you want to continue?";
        bootbox.hideAll();
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._approveUserToEditFeedback(true);
                }
                else {
                    _this._selectPreviousUser();
                }
            }
        });
    };
    FeedbackExecutionController.prototype._selectPreviousUser = function () {
        var _this = this;
        this.loadingUsers = true;
        this.enabledEditForUser = angular.copy(this.previousEnableEditFor);
        if (this.previousEnableEditFor !== null) {
            this.enableEditForAttendeeId = this.previousEnableEditFor.attendeeId;
        }
        else {
            this.enableEditForAttendeeId = this.previouslyEnabledEditForAttendeeId;
            this.enabledEditForUser = this.usersToEditFeedback.find(function (user) { return user.attendeeId == _this.enableEditForAttendeeId; });
        }
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        this.$timeout(function () {
            _this.loadingUsers = false;
        }, 1000);
    };
    FeedbackExecutionController.prototype._alertUserToSaveTheFeedback = function () {
        var _this = this;
        this.enabledEditForUser = angular.copy(this.previousEnableEditFor);
        if (this.previousEnableEditFor == null) {
            this.enableEditForAttendeeId = null;
        }
        bootbox.alert({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Feedback is not saved!</strong></div>",
            message: "Please save your feedback.",
            className: "zIndex1060",
            buttons: {
                ok: {
                    label: 'Ok',
                    className: 'btn-info'
                }
            },
            callback: function () {
                _this._selectPreviousUser();
            }
        });
    };
    FeedbackExecutionController.prototype._approveUserToEditFeedback = function (isApproved, requesterAttendeeId) {
        var _this = this;
        var currentUserAttendeeId = this.usersToEditFeedback.find(function (user) { return user.displayName == 'You'; }).attendeeId;
        var enableEditForAttendeeId = isApproved ? this.enableEditForAttendeeId : requesterAttendeeId;
        var attendeeIds = this.usersToEditFeedback.map(function (attendee) { return attendee.attendeeId; });
        var approvalDetails = {
            attendeeId: enableEditForAttendeeId,
            approverId: currentUserAttendeeId,
            meetingScheduleId: this.parentScheduleId,
            externalMeetingCallId: this.externalMeetingCallId,
            attendeeIds: attendeeIds,
            approved: isApproved
        };
        this.meetingService.giveFeedbackEditApproval(approvalDetails, function (data) {
            if (isApproved) {
                _this.previousEnableEditFor = angular.copy(_this.enabledEditForUser);
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
        });
    };
    FeedbackExecutionController.prototype.requestPermissionToEdit = function () {
        var _this = this;
        // this.disableRequestToEditButton = true;
        var currentUserAttendeeId = this.usersToEditFeedback.find(function (user) { return user.displayName === "You"; }).attendeeId;
        var requestDetails = {
            attendeeId: this.enableEditForAttendeeId,
            externalMeetingCallId: this.externalMeetingCallId,
            requesterAttendeeId: currentUserAttendeeId
        };
        this.meetingService.getFeedbackEditRequestApproval(requestDetails, function (data) {
            if (data) {
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-success mb-0'><i class='fa fa-check fa-fw fa-lg'></i><strong>Request sent!</strong></div>",
                    message: "Request to edit feedback sent.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: function () {
                        //do nothing
                    }
                });
            }
            else {
                // this.disableRequestToEditButton = false;
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Request not sent</strong></div>",
                    message: "Request to edit feedback not sent. Please try after some time.",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: function () {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
        }, function (error) {
            // this.disableRequestToEditButton = false;
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Request not sent</strong></div>",
                message: "Request to edit feedback not sent. Please try after some time.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        });
    };
    FeedbackExecutionController.prototype.openEditFeedbackApprovalModal = function (message) {
        var _this = this;
        this.$uibModalStack.dismissAll();
        var editFeedbackApprovalInfo = {
            requesterName: message.requesterName,
            isFeedbackChanged: this._hasFeedbackChanged()
        };
        this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowTopClass: 'four-dot-five-modal-small',
            backdrop: 'static',
            keyboard: false,
            component: 'feedbackExecutionActionsModal',
            resolve: {
                actionType: function () {
                    return 'feedbackEditApproval';
                },
                editFeedbackApprovalInfo: function () {
                    return editFeedbackApprovalInfo;
                }
            }
        }).result.then(function (callback) {
            if (callback.callbackType == 'saveAndApproveFeedbackEdit') {
                _this.enableEditForAttendeeId = message.requesterAttendeeId;
                if (_this._hasFeedbackChanged()) {
                    _this._saveFeedback('save', function () {
                        _this._approveUserToEditFeedback(true);
                    });
                }
                else {
                    _this._approveUserToEditFeedback(true);
                }
            }
            else if (callback.callbackType == 'approveFeedbackEdit') {
                if (editFeedbackApprovalInfo.isFeedbackChanged) {
                    bootbox.hideAll();
                    bootbox.confirm({
                        closeButton: false,
                        title: "<div class='alert alert-warning mb-0'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                        message: "The changes you made to the feedback will not be saved.<br><br> Do you still want to continue?",
                        buttons: {
                            confirm: {
                                label: 'Yes',
                                className: 'btn-success'
                            },
                            cancel: {
                                label: 'No',
                                className: 'btn-danger'
                            }
                        },
                        callback: function (result) {
                            if (result) {
                                _this.enableEditForAttendeeId = message.requesterAttendeeId;
                                _this._approveUserToEditFeedback(true);
                            }
                        }
                    });
                }
                else {
                    _this.enableEditForAttendeeId = message.requesterAttendeeId;
                    _this._approveUserToEditFeedback(true);
                }
            }
            else if (callback.callbackType == 'denyFeedbackEdit') {
                _this._approveUserToEditFeedback(false, message.requesterAttendeeId);
            }
        }, function (dismiss) {
            //do nothing
        });
    };
    FeedbackExecutionController.prototype._checkAndSaveFeedbackIfMeetingEnd = function () {
        var _this = this;
        this.$rootScope.$on("SAVE_FEEDBACK_ON_MEETING_END", function (event, resolveCallback) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._hasFeedbackChanged()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._saveFeedback('save', function () {
                                console.log('Feedback Saved');
                                if (resolveCallback)
                                    resolveCallback();
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (resolveCallback)
                            resolveCallback();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    FeedbackExecutionController.prototype.getOutreachFeedbackQuestions = function () {
        var _this = this;
        this.loadingFeedbackDetailsFlag = true;
        if (this.outreachData) {
            this.setOutreachFeedbackData(this.outreachData);
        }
        else {
            this.outreachService.getOutreachFeedbackQuestions(this.candidateId, this.companyId, function (data) {
                _this.setOutreachFeedbackData(data);
            }, function (error) {
                _this.alertsAndNotificationsService.showToastMessage(error.message, 'danger');
            });
        }
    };
    FeedbackExecutionController.prototype.setOutreachQuestionsForFeedback = function (clientIds) {
        if (this.recruiterqns && this.recruiterqns.clientDetails) {
            Object.keys(this.recruiterqns.clientDetails).forEach(function (clientId) {
                var el = document.getElementById(clientId);
                if (el) {
                    if (clientIds.includes(clientId)) {
                        el.style.display = "block";
                    }
                    else {
                        el.style.display = "none";
                    }
                }
            });
        }
    };
    FeedbackExecutionController.prototype.setOutreachFeedbackData = function (data) {
        var _this = this;
        this.loadingFeedbackDetailsFlag = false;
        this.recruiterqns = angular.copy(data);
        this.recruiterqns.readOnly = true;
        // this.candidateId = data.candidate.id;
        // this.candidateId = this.candidateId;
        this.feedbackQuestionsCompanyId = null;
        angular.forEach(this.recruiterqns.companyQuestionsResults, function (val, key) {
            _this.feedbackQuestionsCompanyId = key;
        });
        // company questions
        angular.forEach(this.recruiterqns.companyQuestionsResults[this.feedbackQuestionsCompanyId], function (val, key) {
            if (_.isNull(val.id)) {
                val.id = Math.floor((Math.random() * 100) + 1).toString();
                val.isIdValid = false;
                val.randomIdCreatedFlag = true;
                val.showComment = true;
            }
            else {
                val.isIdValid = true;
            }
        });
        // client questions
        angular.forEach(this.recruiterqns.clientQuestionsResults, function (clientVal, clientKey) {
            angular.forEach(clientVal, function (val, key) {
                if (_.isNull(val.id)) {
                    val.id = Math.floor((Math.random() * 100) + 1).toString();
                    val.isIdValid = false;
                    val.randomIdCreatedFlag = true;
                    val.showComment = true;
                }
                else {
                    val.isIdValid = true;
                }
            });
        });
        if (this.recruiterqns.sortedClientList.length == 0) {
            this.clientOrBuExists = false;
        }
        this.displayQuestions = true;
        for (var key in this.recruiterqns.jobDetails) {
            var jobDetailval = this.recruiterqns.jobDetails[key];
            this.type = jobDetailval.feedbackType;
            break;
        }
        if (this.type != 'R') {
            this.showInterested = false;
        }
        this.savedRecruiterQns = angular.copy(this.recruiterqns);
        this.checkifCompanyCompleted();
        this.initializeSliders();
        this.showMeetingLink = false;
        this.loadingFeedbackOptionsFlag = false;
        this.userHasAccessToFeedback = true;
        this.loadingFeedbackDetailsFlag = false;
        this.loadingJobMatchDetailsFlag = false;
        this.$timeout(function () {
            _this.setOutreachQuestionsForFeedback(_this.activeOutreachFeedbackQuestionsList);
        }, 300);
    };
    FeedbackExecutionController.prototype.saveOutreachFeedback = function (successCallback) {
        var _this = this;
        var statusOfSave;
        var listofCompanyQuestions;
        var listofClientQuestions = [];
        var listofJobQuestions = [];
        var overallCommentsQuestionIndex;
        var companyCompleted = true;
        var clientAllCompleted = true;
        var companyOverallCompleted = true;
        if (this.recruiterqns != null) {
            var companyId = this.recruiterqns.candidateOutreachJobMatchInfo ? this.recruiterqns.candidateOutreachJobMatchInfo.jobMatches[0].companyId : this.companyId;
            angular.forEach(this.recruiterqns.companyQuestionsResults[companyId], function (val, key) {
                val.questionareDateTime = _this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                val.questionType = 'O';
                val.lastModifiedBy = _this.candidateId;
                val.participantId = _this.candidateId;
                val.userId = _this.candidateId;
                if (val.question != 'Overall Comment') {
                    if (val.rating == "0" && _this.isEmpty(val.recruiterComment)) {
                        companyCompleted = false;
                    }
                }
                else if (val.question == 'Overall Comment') {
                    if (val.rating == "0" && _this.isEmpty(val.recruiterComment)) {
                        companyOverallCompleted = false;
                    }
                }
            });
            if (!this.disableFeedbackQuestions) {
                listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[companyId];
            }
            else {
                // When questions are disabled, only include the Overall Comment; skip regular company questions
                listofCompanyQuestions = this.recruiterqns.companyQuestionsResults[companyId].filter(function (val) { return val.question && val.question.match(/^Overall/); });
            }
            angular.forEach(this.recruiterqns.clientQuestionsResults, function (clientVal, clientKey) {
                if (_this.activeOutreachFeedbackQuestionsList.includes(clientKey)) {
                    angular.forEach(clientVal, function (val, key) {
                        val.questionareDateTime = _this.dateTimeUtilityService.getCurrentTimeStampInAPIFormat();
                        val.questionType = 'O';
                        val.lastModifiedBy = _this.candidateId;
                        val.participantId = _this.candidateId;
                        val.userId = _this.candidateId;
                        if (val.rating == "0" && _this.isEmpty(val.recruiterComment)) {
                            clientAllCompleted = false;
                        }
                    });
                    if (listofClientQuestions) {
                        listofClientQuestions = listofClientQuestions.concat(clientVal);
                    }
                    else {
                        listofClientQuestions = clientVal;
                    }
                }
            });
        }
        if (this.activeOutreachFeedbackQuestionsList.length > 0 && (!companyCompleted || !clientAllCompleted || !companyOverallCompleted)) {
            if (successCallback) {
                successCallback({ isValid: false, listOfClientQuestions: listofClientQuestions, listOfCompanyQuestions: listofCompanyQuestions });
            }
        }
        else {
            if (successCallback) {
                successCallback({ isValid: true, listOfClientQuestions: listofClientQuestions, listOfCompanyQuestions: listofCompanyQuestions });
            }
        }
    };
    FeedbackExecutionController.prototype.getAllPreferredJobTypes = function () {
        var _this = this;
        this.jobService.getAllJobTypes(function (data) {
            _this.jobTypeList = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    FeedbackExecutionController.prototype.getSalaryDurationOptions = function () {
        var _this = this;
        this.jobService.getSalaryDurationOptions(function (data) {
            _this.salaryDurationOptions = data;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    FeedbackExecutionController.prototype.$onDestroy = function () {
        if (this.externalMeetingCallId) {
            if (this.cleanUpMeetingEventOne) {
                this.cleanUpMeetingEventOne();
            }
            if (this.cleanUpMeetingEventTwo) {
                this.cleanUpMeetingEventTwo();
            }
            if (this.cleanUpMeetingEventThree) {
                this.cleanUpMeetingEventThree();
            }
        }
    };
    return FeedbackExecutionController;
}());
FeedbackExecutionController.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', '$uibModalStack', 'companyService', 'feedbackExecutionService', 'userRoleService', 'jobMatchService', 'candidateService', 'meetingService', 'modalService', 'dateTimeUtilityService', 'alertsAndNotificationsService', 'sharedService', 'MESSAGECONSTANTS', 'outreachService', 'jobService', 'authService'];
// import * as TEMPLATE from './feedback-execution.html;
import * as TEMPLATE from 'raw-loader!./feedback-execution.html';
export var FeedbackExecutionComponent = {
    selector: 'feedbackExecutionScreen',
    component: {
        bindings: {
            jobMatchId: '@',
            candidateId: '@',
            saveCallback: '&',
            completeFeedbackCallback: '&',
            feedbackUserIdsList: '@',
            loginRequired: '<',
            externalCommentRequired: '<',
            feedbackType: '@',
            parentScheduleId: '@',
            childScheduleId: '@',
            context: '@',
            usersToEditFeedback: '<',
            feedbackReadOnly: '<',
            externalMeetingCallId: '=',
            candidateContactDetailsMissingCallback: '&',
            activeOutreachFeedbackQuestionsList: '@',
            outreachData: '@',
            disableFeedbackQuestions: '<',
            isFeedbackTabActive: '<',
            sourceScreen: '@',
            formalizeActivityPayload: '='
        },
        controller: FeedbackExecutionController,
        // templateUrl: 'app/shared/jobMatchActions/feedbackExecution/feedback-execution.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=feedback-execution.component.js.map